import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useEffect, useState } from "react";

import { Actions, FormContent, FormTitle, SaveButton } from "../styles";

const STRATEGIES = {
  infinite_reopening: "Reabertura infinita",
  anticipate_scheduled: "Antecipar débitos agendados"
};

const getWeekendPeriod = () => {
  const now = new Date();
  const startsAt = new Date(now);
  const day = now.getDay();

  if (day === 5 && now.getHours() >= 19) {
    startsAt.setHours(19, 0, 0, 0);
  } else if (day === 6) {
    startsAt.setDate(now.getDate() - 1);
    startsAt.setHours(19, 0, 0, 0);
  } else {
    const daysUntilFriday = (5 - day + 7) % 7;
    startsAt.setDate(now.getDate() + daysUntilFriday);
    startsAt.setHours(19, 0, 0, 0);
  }

  const endsAt = new Date(startsAt);
  endsAt.setDate(startsAt.getDate() + 1);
  endsAt.setHours(23, 59, 59, 999);

  return {
    startsAt: startsAt.toISOString(),
    endsAt: endsAt.toISOString()
  };
};

export const RuleForm = ({
  initialValues,
  productList,
  onSubmit,
  isEditing
}) => {
  const [product, setProduct] = useState(null);
  const [strategy, setStrategy] = useState("anticipate_scheduled");
  const [duration, setDuration] = useState("weekend");
  const [observation, setObservation] = useState("");

  useEffect(() => {
    if (!initialValues) return;
    setProduct(
      productList.find(item => item.id === initialValues.product_base) || null
    );
    setStrategy(initialValues.strategy || "anticipate_scheduled");
    setDuration(initialValues.ends_at ? "weekend" : "permanent");
    setObservation(initialValues.observation || "");
  }, [initialValues, productList]);

  const handleSubmit = event => {
    event.preventDefault();
    const weekendPeriod = getWeekendPeriod();
    const startsAt =
      isEditing && initialValues?.starts_at
        ? initialValues.starts_at
        : duration === "weekend"
        ? weekendPeriod.startsAt
        : new Date().toISOString();

    onSubmit({
      productBaseId: product.id,
      strategy,
      startsAt,
      endsAt: duration === "weekend" ? weekendPeriod.endsAt : null,
      observation
    });
  };

  return (
    <FormContent component="form" onSubmit={handleSubmit}>
      <FormTitle>Produto e estratégia</FormTitle>

      <Autocomplete
        options={productList}
        getOptionLabel={option => option.name}
        value={product}
        disabled={isEditing}
        onChange={(_, value) => setProduct(value)}
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            label="Produto base"
            required
          />
        )}
      />

      <FormControl component="fieldset">
        <FormLabel component="legend">Regra</FormLabel>
        <RadioGroup
          value={strategy}
          onChange={event => setStrategy(event.target.value)}
        >
          {Object.entries(STRATEGIES).map(([value, label]) => (
            <FormControlLabel
              key={value}
              value={value}
              control={<Radio />}
              label={label}
            />
          ))}
        </RadioGroup>
      </FormControl>

      <FormControl component="fieldset">
        <FormLabel component="legend">Vigência</FormLabel>
        <RadioGroup
          value={duration}
          onChange={event => setDuration(event.target.value)}
        >
          <FormControlLabel
            value="weekend"
            control={<Radio />}
            label="Somente neste fim de semana"
          />
          <FormControlLabel
            value="permanent"
            control={<Radio />}
            label="Sem prazo de encerramento"
          />
        </RadioGroup>
      </FormControl>

      <TextField
        multiline
        rows={3}
        variant="outlined"
        label="Observação"
        value={observation}
        inputProps={{ maxLength: 255 }}
        onChange={event => setObservation(event.target.value)}
      />

      <Actions>
        <SaveButton type="submit" variant="contained" disabled={!product}>
          Salvar
        </SaveButton>
      </Actions>
    </FormContent>
  );
};
